import { combineReducers } from '@reduxjs/toolkit';

import chatUnread from './slices/chatUnread';
import notifications from './slices/notifications';
import presence from './slices/presence';
import reminders from './slices/reminders';

const rootReducer = combineReducers({
  chatUnread,
  notifications,
  presence,
  reminders,
});

export default rootReducer;
